import { render, staticRenderFns } from "./image.vue?vue&type=template&id=8df5a2aa&scoped=true&"
import script from "./image.vue?vue&type=script&lang=js&"
export * from "./image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df5a2aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8df5a2aa')) {
      api.createRecord('8df5a2aa', component.options)
    } else {
      api.reload('8df5a2aa', component.options)
    }
    module.hot.accept("./image.vue?vue&type=template&id=8df5a2aa&scoped=true&", function () {
      api.rerender('8df5a2aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/image.vue"
export default component.exports